module.exports = __webpack_public_path__ + "static/media/ir.09a0a4fc.svg";